import { IconProps, IconSize } from "../theme";

interface AlertTriangleProps extends IconProps {
  triangleColor?: string;
  exclamationColor?: string;
}

const AlertTriangle = ({
  size = IconSize.XL,
  triangleColor = "#071443",
  exclamationColor = "#FFFFFF",
}: AlertTriangleProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
    >
      {/* Triangle outline */}
      <path
        d="M29.5999 23.5113L18.6686 4.52758C18.3955 4.06249 18.0055 3.67686 17.5374 3.40891C17.0693 3.14096 16.5393 3 15.9999 3C15.4605 3 14.9305 3.14096 14.4624 3.40891C13.9943 3.67686 13.6043 4.06249 13.3311 4.52758L2.39988 23.5113C2.13705 23.9612 1.99854 24.4728 1.99854 24.9938C1.99854 25.5148 2.13705 26.0265 2.39988 26.4763C2.66954 26.9442 3.05884 27.332 3.52783 27.5997C3.99682 27.8675 4.52861 28.0057 5.06863 28.0001H26.9311C27.4707 28.0052 28.002 27.8669 28.4705 27.5991C28.939 27.3314 29.3279 26.9439 29.5974 26.4763C29.8606 26.0267 29.9995 25.5152 30 24.9942C30.0004 24.4732 29.8623 23.9614 29.5999 23.5113Z"
        fill={triangleColor}
      />
      {/* Exclamation mark */}
      <path
        d="M14.9999 13.0001C14.9999 12.7349 15.1052 12.4805 15.2928 12.293C15.4803 12.1054 15.7347 12.0001 15.9999 12.0001C16.2651 12.0001 16.5194 12.1054 16.707 12.293C16.8945 12.4805 16.9999 12.7349 16.9999 13.0001V18.0001C16.9999 18.2653 16.8945 18.5197 16.707 18.7072C16.5194 18.8947 16.2651 19.0001 15.9999 19.0001C15.7347 19.0001 15.4803 18.8947 15.2928 18.7072C15.1052 18.5197 14.9999 18.2653 14.9999 18.0001V13.0001ZM15.9999 24.0001C15.7032 24.0001 15.4132 23.9121 15.1665 23.7473C14.9198 23.5825 14.7276 23.3482 14.6141 23.0741C14.5005 22.8 14.4708 22.4984 14.5287 22.2074C14.5866 21.9165 14.7294 21.6492 14.9392 21.4394C15.149 21.2296 15.4163 21.0868 15.7072 21.0289C15.9982 20.971 16.2998 21.0007 16.5739 21.1143C16.848 21.2278 17.0823 21.4201 17.2471 21.6667C17.4119 21.9134 17.4999 22.2034 17.4999 22.5001C17.4999 22.8979 17.3418 23.2794 17.0605 23.5607C16.7792 23.842 16.3977 24.0001 15.9999 24.0001Z"
        fill={exclamationColor}
      />
    </svg>
  );
};

export default AlertTriangle;
